import { RobotIndustrialIcon } from './RobotIndustrialIcon';

/**
 * author: Michael Richins
 * id C008FBCE-4D0A-4003-8811-FF15D08C3313
 * name robot-industrial
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-industrial.svg
 * tags
 * - Hardware / Tools 
 */
export const AssemblyIcon = RobotIndustrialIcon;
export default AssemblyIcon